/*
 * Il super admin che modifica i dati di un altro utente (anagrafiche): serve la rotta `PATCH /administration/profiles/{userId}` nel
 * backend (sportid-docs, «modifiche 12 ottobre», cap. 3). Finche' non c'e' resta spento: REACT_APP_SUPERADMIN_MODIFICA=S nei file .env
 * (o nel .env.development.local) accende le schede in modifica; spento, le schede restano in sola lettura come prima.
 */
export const SUPERADMIN_PUO_MODIFICARE = String(process.env.REACT_APP_SUPERADMIN_MODIFICA ?? 'N').trim().toUpperCase() === 'S';
